import PageNotifications from "components/Layout/PageNotifications";
import PropTypes from "prop-types";
import "./Main.scss";

const Main = ({ children, className }) => (
    <>
        <main className={`main ${className || ""}`}>
            <PageNotifications />
            <div className="main__content">{children}</div>
        </main>
    </>
);

Main.defaultProps = {
    children: null,
    className: "",
    MainSidebarRight: null,
};

Main.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
};

export default Main;
